
import { Options, prop, Vue } from "vue-class-component";
import DetailBranchClient from "./detail-client-info/detail-branch.client.vue";
import DetailTaxInfo from "./detail-client-info/detail-tax-information.vue";
import DetailContactInfo from "./detail-client-info/detail-contact-information.vue";
import DetailBillingInfo from "./detail-client-info/detail-billing-info.vue";
import DetailCoopAgreement from "./detail-client-info/detail-coop-agreement.vue";
import DetailBankInfo from "./detail-client-info/detail-bank-info.vue";
import DetailBankSettlement from "./detail-client-info/detail-bank-settlement.vue";
import CardTabDetail from "../../card-tab-detail.vue";
import { ClientManagementController } from "@/app/ui/controllers/ClientManagementController";
import { ClientRegistrationController } from "@/app/ui/controllers/ClientRegistrationController";
import { ClientDetailUpdateItem } from '@/domain/entities/ClientManagement';
import formatDate from "@/app/infrastructures/misc/common-library/v2/FormatDate";

class Props {
  title = prop<string>({
    default: "Detail",
    required: true,
    type: String
  });
  isManagement = prop<boolean>({
    default: false,
    required: false,
    type: Boolean
  });
  detailData = prop<any>({
    default: "",
    type: Object
  })
}

@Options({
  emits: ["action"],
  components: {
    DetailBranchClient,
    DetailTaxInfo,
    DetailContactInfo,
    DetailBillingInfo,
    DetailCoopAgreement,
    DetailBankInfo,
    DetailBankSettlement,
    CardTabDetail
  }
})
class ClientDetailCard extends Vue.with(Props) {
  get tabModels() {
    return [
      { slotName: "klien", name: this.$t("clientManagement.managementDetail.tabs.client").toString() },
      { slotName: "pajak", name: this.$t("clientManagement.managementDetail.tabs.tax").toString() },
      { slotName: "kontak", name: this.$t("clientManagement.managementDetail.tabs.contact").toString() },
      { slotName: "pembayaran", name: this.$t("clientManagement.managementDetail.tabs.payment").toString() },
      { slotName: "billing", name: this.$t("clientManagement.managementDetail.tabs.billing").toString() },
      {
        slotName: "perjanjian-kerjasama",
        name: this.$t("clientManagement.managementDetail.tabs.cooperationAgreement").toString()
      },
      { slotName: "bank", name: this.$t("clientManagement.managementDetail.tabs.bank").toString() },
      { slotName: "bank-settlement", name: this.$t("clientManagement.managementDetail.tabs.bankSettlement").toString() }
    ];
  }

  get clientPaymentMethod() {
    if (this.isManagement) {
      return ClientManagementController.detailClientManagement
        .clientPaymentMethod.name;
    } else {
      return ClientRegistrationController.clientRegistrationDetail
        .clientPaymentMethod.name;
    }
  }

  get detailData() {
    if (this.isManagement) {
      return ClientManagementController.detailClientManagement;
    }

    return ClientRegistrationController.clientRegistrationDetail;
  }

  get newestUpdatedPayment() {
    if (this.detailData.detailUpdate.newestUpdatedPayment.length) {
      return this.detailData.detailUpdate.newestUpdatedPayment[0]
    }

    return new ClientDetailUpdateItem({
      updatedByName: this.detailData.clientCreatedBy,
      updatedAt: formatDate(this.detailData.clientCreatedAt)
    })
  }
}
export default ClientDetailCard; 
